import RightGoogleMap from "../../common/RightGoogleMap"
import SetUpHeader from "../../common/SetUpHeader"
import SetUpLayout from "../../common/SetUpLayout"
import LayoutMain from "./LayoutMain"

type Props = {}

const PipesConfig = (props: Props) => {
  return (
    <SetUpLayout
      title='Pipes'

      header={
        <SetUpHeader />
      }
      rightLayout={<RightGoogleMap style={{
        width: { xs: '488px' },
      }} />}
    >
      <LayoutMain title="Data 2 of 9" subtitle="Pipes" />
    </SetUpLayout>
  )
}

export default PipesConfig